export default class CustomError extends Error {
  code?: string;
  handled: boolean;

  constructor({ message, name = 'Unnamed', handled = false, code }: 
    { message: string; name?: string; handled?: boolean; code?: string }) {
    super(message); // Imposta il messaggio di errore
    this.name = name; // Nome dell'errore
    this.code = code; // Codice dell'errore
    this.handled = handled; // Indica se è stato già gestito
  }

  toJSON() {
    return {
      message: this.message,
      name: this.name,
      code: this.code,
      handled: this.handled,
    };
  }
}